var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
import { useAcceptVto } from '../../../../../hooks';
import { getDurationStr, getTimeIntervalStr } from '@amzn/atoz-shiftapp-utilities';
import { DateTime } from 'luxon';
export var useVTOAvailableCardData = function (_a) {
    var vtoOpportunity = _a.vtoOpportunity, setModalContent = _a.setModalContent, setModalError = _a.setModalError;
    var openVtoConfirmation = useAcceptVto({
        vtoOpportunity: vtoOpportunity,
        setModalContent: setModalContent,
        setModalError: setModalError
    }).openVtoConfirmation;
    var durationStr = getDurationStr(vtoOpportunity.shift.duration);
    var intervalStr = getTimeIntervalStr(DateTime.fromISO(vtoOpportunity.shift.timeRange.start), DateTime.fromISO(vtoOpportunity.shift.timeRange.end));
    return {
        openVtoConfirmation: openVtoConfirmation,
        durationStr: durationStr,
        intervalStr: intervalStr
    };
};
useVTOAvailableCardData.fragments = {
    shiftOpportunity: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        fragment UseVtoAvailableCardData_ShiftOpportunity on ShiftOpportunity {\n            id\n            shift {\n                duration {\n                    value\n                }\n                timeRange {\n                    start\n                    end\n                }\n            }\n            ...useAcceptVto_ShiftOpportunity\n        }\n\n        ", "\n    "], ["\n        fragment UseVtoAvailableCardData_ShiftOpportunity on ShiftOpportunity {\n            id\n            shift {\n                duration {\n                    value\n                }\n                timeRange {\n                    start\n                    end\n                }\n            }\n            ...useAcceptVto_ShiftOpportunity\n        }\n\n        ", "\n    "])), useAcceptVto.fragments.shiftOpportunity)
};
var templateObject_1;
